module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlDetails", "Details" ) ))==null?'':__t)+
'</h5></header><div data-region="details-container"><dl> ';
 if ( showSerialNumber ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Serial number:") ))==null?'':__t)+
'</dt><dd>'+
((__t=( serial ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( unitType ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "Unit", "Device type:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( unitType ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( showApiVersion ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Api version:") ))==null?'':__t)+
'</dt><dd class="api-version">'+
((__t=( apiVersion ))==null?'':__t)+
'</dd> ';
 } 
__p+=' <button class="upgrade-button ';
 if ( !upgradeAvailable ||  offline ) { 
__p+=' hidden';
 } 
__p+='" data-click="upgrade-firmware">'+
((__t=( i18n.tc( "BluetoothSettings", "Update firmware" ) ))==null?'':__t)+
'</button> ';
 if ( showTestResult ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Testing:") ))==null?'':__t)+
'</dt> ';
 if ( ! tested ) { 
__p+=' <dd class="error">'+
((__t=( i18n.tc("Unit|Testing", "Incomplete") ))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dd class="success">'+
((__t=( i18n.tc("Unit|Testing", "Completed") ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 } 
__p+=' ';
 if ( insuranceCompanyName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Insurance company:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( insuranceCompanyName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( alarmCentralName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Alarm central:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( alarmCentralName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( vehicleName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Vehicle:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( vehicleName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( customerName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Registered to:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( customerName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( subscriptionName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Subscription:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( subscriptionName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( transientInstallerName ) { 
__p+=' <dt>'+
((__t=( i18n.tc("Unit", "Installer:") ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientInstallerName ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl><fieldset class="button-wrap"><button class="primary" data-click="details-close">'+
((__t=( i18n.tc("UnitAlias", "Close") ))==null?'':__t)+
'</button></fieldset></div>';
}
return __p;
};
